<template>
  <a-modal
    :open="open"
    class="connections-modal"
    title="Conexiones"
    width="500px"
    :maskClosable="false"
    centered
    @cancel="handleClose"
  >
    <a-divider class="divider" />
    <div class="connections-modal__body">
      <h2 class="name">Este conector de API tiene {{ countConnections }} conexiones:</h2>

      <div class="connections">
        <div
          v-for="(items, type) in groupedConnections"
          :key="type"
          class="connections-group"
        >
          <!-- HEADER -->
          <div class="connections-group__header">
            {{ ConnectionTypeGroup[type as ConnectionType] }} ({{ items.length }})
          </div>

          <!-- LIST (CLAVE) -->
          <div class="connections-list">
            <div
              v-for="item in items"
              :key="item.id"
              class="connections-item"
            >
              <span class="connections-item__name" :title="item.name">
                {{ item.name }}
              </span>

              <a-tag :color="item.status === 1 ? 'green' : 'default'">
                {{ item.status === 1 ? 'Activo' : 'Inactivo' }}
              </a-tag>
            </div>

            <!-- EMPTY STATE (para Chatbot 0) -->
            <div v-if="items.length === 0" class="connections-empty">
              Sin conexiones
            </div>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="footer">
        <a-button @click="handleClose">
          Cerrar detalles
        </a-button>
      </div>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRouter } from "vue-router";
import { Connector } from "@/@types/ivr";
import { useScrollResize } from "@/app/shared/composables/useScrollResize";
import { ConnectionType, ConnectionTypeGroup } from "../../utils/enums";

const props = defineProps<{
  connector: Connector | undefined;
  open: boolean;
}>();

const emit = defineEmits<{ "update:open": [open: boolean]; update: [] }>();
const { scrollStyle } = useScrollResize({ headerHeight: 240, width: 400 });

// Columnas del a-table
const columns = [
  {
    title: "Nombre del IVR Operador Automático",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Estado",
    dataIndex: "status",
    key: "status",
    width: 120,
    slots: { customRender: "status" },
  },
];

const handleClose = () => emit("update:open", false);

const groupedConnections = computed(() => {
  const baseGroups: Record<ConnectionType, any[]> = {
    [ConnectionType.Ivr]: [],
    [ConnectionType.Chatbot]: [],
  };

  props.connector?.connections?.forEach((conn) => {
    baseGroups[conn.type]?.push(conn);
  });

  return baseGroups;
});

const countConnections = computed(() => {
  return props.connector?.connections?.length;
});
</script>

<style scoped lang="sass">
.type
  font-size: 12px
  color: $text-secondary
  line-height: 20px
.name
  font-weight: 600
  font-size: 16px
  color: $gray-9
  margin-bottom: 2px
  margin-top: 10px
.description
  font-weight: 400
  font-size: 14px
  color: $gray-8
  .count
    color: $primary
    font-weight: 500
.footer
  display: flex
  align-items: center
  justify-content: center
  padding: 13px 20px
  // border-top: $border-normal
  position: absolute
  width: 100%
  bottom: 0
  left: 0
  margin-top: 20px

.divider
  position: absolute
  left: 0
  top: 45px
  margin: 10px 0

.connections-modal
  padding: 4px 0
  &__list
    padding-inline-start: 25px
    color: $gray-9
    li
      margin-top: 10px
  &__body
    padding-top: 15px

  .connections
    margin-bottom: 50px

  .connections-group
    margin-top: 15px

    &__header
      font-size: 14px
      font-weight: 600
      color: #262626
      margin-bottom: 8px

  .connections-list
    display: flex
    flex-direction: column

  .connections-item
    display: flex
    align-items: center
    justify-content: space-between

    padding: 10px 12px
    border-bottom: 1px solid #f0f0f0

    transition: background 0.2s ease

    &:hover
      background: #fafafa


:global(.connector-ivr .ant-modal-footer)
  margin-top: 60px !important
</style>
